import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import { IAPI_TEM001_Response } from "../../../type/apiType";

/**
 * テンプレート一覧参照API
 * @return httpTemplatesList
 */
const httpAPI_TEM001 = async (): Promise<IAPI_TEM001_Response> => {
  let res = await http.post(ApiUrl.API_TEM001);

  return res.data;
};

export { httpAPI_TEM001 };
